export default __webpack_public_path__ + "static/media/LoginImage.fc4e020f.svg";